"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var componentsMap_1 = require("../componentsMap");
var constants_1 = require("../constants");
var DesignSystemTemplate_1 = __importDefault(require("../DesignSystemTemplate"));
var ImportCodeTemplate_1 = __importDefault(require("../ImportCodeTemplate"));
var utils_1 = require("../utils");
var logoAndNameSectionDefs_1 = require("./logoAndNameSectionDefs");
var LogoAndName = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ImportCodeTemplate_1.default, { heading: "LogoAndName Import", renderCode: 'import LogoAndName from \'atomicComponents/molecules/Image/LogoAndName\';' }), logoAndNameSectionDefs_1.logoAndNameSectionDefs.map(function (sectionDef) { return ((0, jsx_runtime_1.jsx)(DesignSystemTemplate_1.default, { heading: sectionDef.heading, vertical: sectionDef === null || sectionDef === void 0 ? void 0 : sectionDef.vertical, description: sectionDef.description, previewStackProps: sectionDef === null || sectionDef === void 0 ? void 0 : sectionDef.previewStackProps, renderPreview: sectionDef.variations.map(function (variation) {
                var _a, _b;
                var Component = componentsMap_1.LOGOANDNAME_COMPONENT_MAP[variation.component];
                return ((0, jsx_runtime_1.jsx)(Component, __assign({ brand: constants_1.sampleServices[0] }, Object.fromEntries((_b = (_a = variation.properties) === null || _a === void 0 ? void 0 : _a.map(function (p) { var _a; return [p.prop, (_a = p.v) !== null && _a !== void 0 ? _a : true]; })) !== null && _b !== void 0 ? _b : [])), variation.component));
            }), renderCode: sectionDef.variations.map(utils_1.makeVariationString).join('\n') }, sectionDef.heading)); })] })); };
exports.default = LogoAndName;
